import { SET_CUSTOMER, RESET_CUSTOMER } from '../actions/customer_actions';


const initialState = {
  customer: {}
};

export const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOMER: {
      return {
        ...state,
        customer: { ...action.customer }
      }
    }
    case RESET_CUSTOMER: {
      return {
        ...state,
        customer: {}
      }
    }
    default: return state;
  }
}
